export interface ProblemBody {
  readonly detail: string | null;
  readonly code: string | null;
  readonly fieldErrors: Readonly<Record<string, readonly string[]>>;
}

/** A 429/502 from a rate limiter or proxy may never have reached the application and so has no problem document — a parse failure here is not itself an error. */
export async function readProblem(response: Response): Promise<ProblemBody> {
  try {
    const body = (await response.json()) as Partial<{
      title: string;
      detail: string;
      code: string;
      errors: Record<string, string[]>;
    }>;
    const fieldErrors = body.errors ?? {};
    /** A validation problem carries the useful message in `errors`, not `detail` (which is just a generic title) — falling back to the title alone would show the player nothing actionable. */
    const firstFieldMessage = Object.values(fieldErrors)[0]?.[0];
    return {
      detail: body.detail ?? firstFieldMessage ?? body.title ?? null,
      code: body.code ?? null,
      fieldErrors,
    };
  } catch {
    return { detail: null, code: null, fieldErrors: {} };
  }
}
